import React from 'react';
import GraphViewControlBar from '../GraphViewControlBar.tsx';
import { ChartType } from '../../../../pages/Summary/Components/Charts/ChartTypes.ts';

/**
 * InvoiceDetailsType - Component for rendering the GraphViewControlBar with
 * invoice details view options
 */
const InvoiceDetailsType: React.FC = () => {
	return <GraphViewControlBar viewAll={true} chartType={ChartType.INVOICE_DETAILS} />;
};

export default InvoiceDetailsType;
